module.exports = __webpack_public_path__ + "static/media/icePink.37a0a180.jpg";